export const CITIES_ACTIONS = {
  REQUESTED: 'cities/requested',
  SUCCEEDED: 'cities/succeeded',
  FAILED: 'cities/failed',
};

export interface CitiesSucceeded {
  type: string;
  payload: { cities: any[]; region: any };
}

export const citiesSucceeded = (
  cities: any[],
  region: any,
): CitiesSucceeded => ({
  type: CITIES_ACTIONS.SUCCEEDED,
  payload: { cities, region },
});

export interface CitiesRequested {
  type: string;
  payload: { regionId: string };
}

export const citiesRequested = (regionId: string): CitiesRequested => ({
  type: CITIES_ACTIONS.REQUESTED,
  payload: { regionId },
});

export interface CitiesFailed {
  type: string;
  error: string;
}

export const citiesFailed = (error: string) => ({
  error,
  type: CITIES_ACTIONS.FAILED,
});

export type CitiesAction = CitiesRequested | CitiesSucceeded | CitiesFailed;



// WEBPACK FOOTER //
// ./src/scenes/Cities/services/actions.ts